import { t } from "i18next";

export const TOOLTIP_PROPS = {
  save: {
    content: t("neetoMolecules.common.actions.save"),
    position: "top",
    delay: 300,
  },
  cancel: {
    content: t("neetoMolecules.common.actions.cancel"),
    position: "top",
    delay: 300,
  },
};
